export default __webpack_public_path__ + "static/media/ServiceDeliverySpecialistRole_InformationArchitecture_Thumbnail.be7a6e1f.png";